/**
 * 작업사진 갤러리 (/adm/order/photo-gallery)
 * ($j.Pages.Admin.OrderPhotoGallery / body data-page-name="OrderPhotoGallery")
 *
 * 서류 마스터의 '등록된 서류' 갤러리(DocMaster.js)와 같은 얼개다 — 카드 하나가 오더 하나,
 * 누르면 그 오더의 현장사진을 $j.Ui.ZoomPhoto 로 넘겨 본다. 쪽 넘기기도 같은 모양(DataTables 크롬)이다.
 * 뷰어의 이전/다음은 그 오더 안이 아니라 지금 쪽에 깔린 모든 오더의 사진을 오더 경계 없이 넘긴다
 * (장수 n/length 는 오더 안에서 세고, meta 의 오더번호로 어느 오더인지 보인다). 지도 핀만 예외다 —
 * 핀의 대표 오더는 목록에 없으므로 그 오더 안에서만 넘긴다.
 *
 * 지도로 보기 — 서버가 보이는 영역을 칸으로 나눠 준 묶음 핀(칸마다 최신 오더 사진 + 건수)을 찍는다.
 * 아래 카드 목록은 같은 영역 안으로 좁혀진다. 카카오 SDK 는 지도를 처음 켤 때만 싣는다.
 *
 * 거르기 — 기간(작업일, 기본 1년) · 발주소속(본사) · 업종 · 기종·옵션 · 수주자(회원) · 오더번호.
 * 수주자·오더번호는 접수목록과 같은 규약('이름#번호', 콤마로 여러 오더)이고 '검색' 버튼/엔터로 적용한다.
 * 수주자 검색은 '사진 올린 사람(g5_order_photos.mb_no)' 기준이다 — 소유자를 고르면 그 팀(소속자 포함)이 올린 사진, 소속자면 본인이 올린 사진(서버).
 * 오더번호를 넣으면 기간 제한이 풀린다(서버). 기종·옵션은 기사관리의 차량검색 모달
 * ($j.F.Admin.Member.CarSearchModal)을 한 기종 모드로 연다.
 * 고른 값은 숨기지 않고 옆 칩에 글로 보인다 — 칩의 ✕ 가 곧 해제다.
 *
 * 여러 장인 카드에 1초 머무르면 그 오더의 사진을 작게 펼쳐 보인다(#opgPeek).
 */
import Util from '../../Common/Util';
export default class OrderPhotoGallery {
    initialize() {
        this.res     = null;
        this.mode    = 'list';
        this.map     = null;
        this.pins    = [];
        this.mapSeq  = 0;   // 지도를 빨리 끌면 응답 순서가 뒤집힌다 — 마지막 요청 것만 그린다
        this.listSeq = 0;
        this.car     = null;   // 기종·옵션 모달 결과 {car_type, car_range, option}

        $('#opgPeriod').on('change', () => {
            const custom = $('#opgPeriod').val() === 'custom';
            $('#opgDates').prop('hidden', !custom);
            if (!custom) this._reload();
        });
        $('#opgFrom, #opgTo').on('change', () => { if ($('#opgFrom').val()) this._reload(); });
        // 기간지정 달력은 mobiscroll — 데스크톱만(모바일은 기본 input). 접수목록 d1/d2 와 같은 규약
        if (!$j.Common.Util.isMobile()) {
            $('#opgFrom, #opgTo').mobiscroll().datepicker({
                controls: ['calendar'],
                dateFormat: 'YYYY-MM-DD',
                locale: mobiscroll.localeKo,
                buttons: [],   // 설정/확인 버튼 제거 — 고르면 즉시 반영(change → _reload)
            });
        }
        $('#opgSosok').on('change', () => this._reload());
        // 기종·옵션은 업종에 딸린 값이다 — 업종을 바꾸면 같이 푼다
        $('#opgCat').on('change', () => { this.car = null; this._drawCarChip(); this._reload(); });
        $('#opgCarBtn').on('click', () => this._openCarModal());
        $('#opgCarChip').on('click', '.opg-chip-x', () => { this.car = null; this._drawCarChip(); this._reload(); });

        // 수주자(회원)·오더번호 — 접수목록과 같은 규약('이름#번호'). 자동완성은 공용 컴포넌트를 그대로.
        // 자동완성 선택/엔터로는 자동검색하지 않는다(값만 채움) — '검색' 버튼이나 엔터로 적용한다.
        $j.F.Admin.Util.memberSearch('opgWorker');
        $('#opgFind').on('click', () => this._reload());
        $('#opgWorker, #opgNums').on('keydown', (e) => {
            // 엔터: 자동완성 목록에서 고르는 중(활성 항목 있음)이면 그 선택이 먼저다
            if (e.key === 'Enter' && $j.F.Admin.AutoComplete.getIndex('opgWorker') < 0) this._reload();
        });
        this._bindPeek();
        $('#opgMode').on('click', 'button', (e) => this._setMode($(e.currentTarget).data('mode')));
        $('#opgList')
            .on('click', '.opg-card', (e) => this._openViewer(parseInt($(e.currentTarget).data('i'))))
            .on('click', '.opg-order', (e) => {
                e.stopPropagation();   // 오더번호는 핸들 팝업 — 카드의 뷰어를 같이 열지 않는다
                const n = parseInt($(e.currentTarget).data('n'));
                $j.F.Admin.Util.openOrderHandle(n, {name: `order_handle_${n}`});
            })
            .on('click', '.opg-page', (e) => this._load(parseInt($(e.currentTarget).data('p')), true));

        this._load(1);
    }

    /** 거르기가 바뀌면 목록은 1쪽부터, 지도는 핀을 다시 */
    _reload() {
        this._load(1);
        if (this.mode === 'map') this._loadPins();
    }

    /** 서버로 보낼 거르기 값 — 목록·지도가 같은 것을 쓴다 */
    _filter() {
        const f = {
            category:  $('#opgCat').val() || '',
            sosok:     $('#opgSosok').val() || '',
            car_range: this.car ? this.car.car_range || '' : '',
            options:   this.car ? this.car.option || '' : '',
            ws:        $('#opgWorker').val() || '',   // 수주자 회원 ('이름#번호' 규약)
            n:         $('#opgNums').val() || '',      // 오더번호 (콤마로 여러 건)
        };
        const period = $('#opgPeriod').val();
        if (period === 'custom') {
            f.from = $('#opgFrom').val() || '';
            f.to   = $('#opgTo').val() || '';
        } else {
            f.from = dayjs().subtract(parseInt(period), 'month').format('YYYY-MM-DD');
        }
        return f;
    }

    // ── 기종·옵션 ────────────────────────────────────────────────

    _openCarModal() {
        $j.F.Admin.Member.CarSearchModal.open({
            single: true,
            car: this.car || {car_type: $('#opgCat').val() || ''},
            onApply: (data) => {
                if (!data.car_type) { this.car = null; }
                else {
                    this.car = {car_type: data.car_type, car_range: data.car_range || '', option: data.option || ''};
                    $('#opgCat').val(data.car_type);
                }
                this._drawCarChip();
                this._reload();
            },
            onClear: () => { this.car = null; this._drawCarChip(); this._reload(); },
        });
    }

    /** 고른 기종·옵션을 글로 — 숨은 상태를 두지 않는다 */
    _drawCarChip() {
        const c = this.car;
        if (!c || (!c.car_range && !c.option)) { $('#opgCarChip').empty(); return; }
        const range = c.car_range ? $j.F.Car.getCarRangeStr({car_type: c.car_type, car_range: c.car_range}) : '';
        const label = [range, c.option ? `옵션 ${c.option}` : ''].filter(Boolean).join(' · ');
        $('#opgCarChip').html(`<span class="opg-chip">${this._esc(label)}
            <button type="button" class="opg-chip-x" title="기종·옵션 해제">&times;</button></span>`);
    }

    // ── 여러 장 미리보기 ─────────────────────────────────────────

    /**
     * 카드에 1초 머무르면 그 오더의 사진을 카드 옆에 펼친다. 스치기만 해서는 안 뜬다.
     * 펼친 판으로 마우스를 옮겨도 닫히지 않게, 떠날 때는 잠깐 기다렸다 닫는다.
     *
     * 뒤가 온통 사진이라 판이 묻힌다 — 화면을 어둡게 깔고(#opgPeekDim) 그 위에 띄운다.
     * 어둠막은 마우스를 받지 않는다 — 받으면 카드의 mouseleave 가 즉시 나서 판이 닫힌다.
     */
    _bindPeek() {
        const $dim  = $('<div id="opgPeekDim" hidden></div>').appendTo('body');
        const $peek = $('<div id="opgPeek" hidden></div>').appendTo('body');
        let openTimer = null, closeTimer = null;
        const close = () => {
            clearTimeout(openTimer);
            $peek.prop('hidden', true);
            $dim.prop('hidden', true);
            $('#opgList .opg-card.is-peek').removeClass('is-peek');
        };
        const closeSoon = () => { clearTimeout(openTimer); clearTimeout(closeTimer); closeTimer = setTimeout(close, 200); };

        $('#opgList')
            .on('mouseenter', '.opg-card', (e) => {
                clearTimeout(openTimer); clearTimeout(closeTimer);
                const card = e.currentTarget;
                const o = this.res && this.res.orders[parseInt($(card).data('i'))];
                if (!o || o.photos.length < 2) return close();
                openTimer = setTimeout(() => {
                    $('#opgList .opg-card.is-peek').removeClass('is-peek');
                    $(card).addClass('is-peek');
                    $dim.prop('hidden', false);
                    this._showPeek($peek, card, o);
                }, 1000);
            })
            .on('mouseleave', '.opg-card', closeSoon);
        $peek
            .on('mouseenter', () => clearTimeout(closeTimer))
            .on('mouseleave', closeSoon)
            .on('click', '.opg-peek-img', (e) => {
                close();
                this._openAll(this.res.orders.indexOf(this._peekOrder), parseInt($(e.currentTarget).data('n')));
            });
        this._closePeek = close;
    }

    _showPeek($peek, card, o) {
        this._peekOrder = o;
        $peek.html(`<div class="opg-peek-head">
                <b>${this._esc(o.carType)} ${this._esc(o.carOption)}</b>
                <span>${this._esc(o.area)} · ${this._esc(o.workDay)}</span>
                <em>${o.photos.length}장</em>
            </div>
            <div class="opg-peek-grid">${o.photos.map((p, n) =>
            `<div class="opg-peek-img" data-n="${n}" title="${this._esc(p.tag || '')}">
                <img src="${this._esc(p.thumb)}" alt="" onerror="this.remove()">
                ${p.tag ? `<span>${this._esc(p.tag)}</span>` : ''}
            </div>`).join('')}</div>`).prop('hidden', false);

        // 카드 오른쪽에 — 화면을 넘으면 왼쪽으로. 세로는 화면 안에 들인다
        const r = card.getBoundingClientRect();
        const w = $peek.outerWidth(), h = $peek.outerHeight();
        let left = r.right + 8;
        if (left + w > window.innerWidth - 8) left = Math.max(8, r.left - w - 8);
        const top = Math.max(8, Math.min(r.top, window.innerHeight - h - 8));
        $peek.css({left: left + window.scrollX, top: top + window.scrollY});
    }

    async _load(page, scroll = false) {
        if (this._closePeek) this._closePeek();
        const seq  = ++this.listSeq;
        const data = Object.assign({page}, this._filter());
        if (this.mode === 'map') {
            if (!this.map) return;   // 지도가 뜨고 첫 idle 에서 다시 불린다
            data.bbox = this._bbox();
        }
        try {
            const res = await $.ajax({url: '/adm/ajax/order/photo-gallery', type: 'get', dataType: 'json', data});
            if (seq !== this.listSeq) return;
            if (!res.ok) return Util.swalert(res.message || '사진을 불러오지 못했습니다.');
            this.res = res;
            $('#opgList').html(this._listHtml(res));
            // 쪽을 넘길 때만 목록 머리로 — 지도를 끌 때마다 튀면 지도를 놓친다
            if (scroll) $('#opgList')[0].scrollIntoView({block: 'start'});
        } catch (e) {
            if (seq === this.listSeq) Util.swalert('사진을 불러오지 못했습니다.');
        }
    }

    // ── 지도로 보기 ───────────────────────────────────────────────

    async _setMode(mode) {
        if (mode === this.mode) return;
        this.mode = mode;
        $('#opgMode button').removeClass('active').filter(`[data-mode="${mode}"]`).addClass('active');
        $('#opgMapWrap').prop('hidden', mode !== 'map');

        if (mode === 'list') return this._load(1);

        if (!this.map) {
            try {
                await this._loadKakao();
            } catch (e) {
                return Util.swalert('지도를 불러오지 못했습니다.');
            }
            this.map = new kakao.maps.Map(document.getElementById('opgMap'), {
                center: new kakao.maps.LatLng(36.3, 127.8), level: 13,   // 전국
            });
            this.map.addControl(new kakao.maps.ZoomControl(), kakao.maps.ControlPosition.RIGHT);
            // 끄는 동안 계속 부르지 않게 멈춘 뒤 한 번만
            kakao.maps.event.addListener(this.map, 'idle', () => {
                clearTimeout(this._idleTimer);
                this._idleTimer = setTimeout(() => { this._loadPins(); this._load(1); }, 250);
            });
        } else {
            this.map.relayout();   // 숨겨져 있던 동안 크기를 못 잰다
        }
        this._loadPins();
        this._load(1);
    }

    /** SDK 는 autoload=false 로 — 늦게 싣는 스크립트에서 기본 방식(document.write)은 안 먹는다 */
    _loadKakao() {
        if (window.kakao && kakao.maps && kakao.maps.LatLng) return Promise.resolve();
        const key = $('#opgRoot').data('kakao-key');
        return new Promise((resolve, reject) => {
            const s   = document.createElement('script');
            s.src     = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${encodeURIComponent(key)}&autoload=false`;
            s.onload  = () => kakao.maps.load(resolve);
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }

    /** 지금 보이는 영역 — 서버 규약 '남,서,북,동' */
    _bbox() {
        const b = this.map.getBounds();
        const sw = b.getSouthWest(), ne = b.getNorthEast();
        return [sw.getLat(), sw.getLng(), ne.getLat(), ne.getLng()].map((v) => v.toFixed(5)).join(',');
    }

    async _loadPins() {
        if (!this.map) return;
        const seq = ++this.mapSeq;
        try {
            const res = await $.ajax({
                url: '/adm/ajax/order/photo-gallery/map', type: 'get', dataType: 'json',
                data: Object.assign({bbox: this._bbox()}, this._filter()),
            });
            if (seq !== this.mapSeq || !res.ok) return;
            this._drawPins(res.cells);
        } catch (e) { /* 다음 idle 에서 다시 부른다 */ }
    }

    _drawPins(cells) {
        this.pins.forEach((p) => p.setMap(null));
        this.pins = cells.map((c) => {
            const o     = c.latest;
            const first = o.photos[0];
            const el    = document.createElement('div');
            el.className = 'opg-pin' + (c.cnt > 1 ? ' opg-pin--many' : '');
            el.title     = c.cnt > 1 ? `${c.cnt.toLocaleString()}건 — 눌러서 확대` : `${o.carType} · ${o.area}`;
            el.innerHTML = (first ? `<img src="${this._esc(first.thumb)}" alt="" loading="lazy" onerror="this.remove()">` : '')
                + (c.cnt > 1 ? `<span class="opg-pin-cnt">${c.cnt > 999 ? '999+' : c.cnt}</span>` : '');

            const pos = new kakao.maps.LatLng(c.lat, c.lng);
            el.addEventListener('click', () => {
                const level = this.map.getLevel();
                // 여러 건이면 그 자리로 파고든다. 더 파고들 수 없을 만큼 가까우면 대표 오더를 연다
                if (c.cnt > 1 && level > 2) {
                    this.map.setLevel(Math.max(1, level - 3), {anchor: pos});
                } else {
                    this._showOrder(o);
                }
            });

            const ov = new kakao.maps.CustomOverlay({position: pos, content: el, yAnchor: 1, clickable: true});
            ov.setMap(this.map);
            return ov;
        });
    }

    _openViewer(i) {
        this._closePeek();
        this._openAll(i);
    }

    /**
     * 지금 쪽에 깔린 모든 오더의 사진을 한 줄로 이어 뷰어를 연다 — 이전/다음이 오더 경계를 넘는다.
     * orderIdx 오더의 photoIdx 장을 첫 화면으로. (이번 응답 res.orders 안으로 한정 — 다음 쪽은 넘지 않는다)
     */
    _openAll(orderIdx, photoIdx = 0) {
        const o = this.res && this.res.orders[orderIdx];
        if (!o || !o.photos.length) return;
        const items = [];
        let index = 0;
        this.res.orders.forEach((od, oi) => {
            if (oi === orderIdx) index = items.length + photoIdx;
            od.photos.forEach((p, n) => items.push(this._item(od, p, n)));
        });
        $j.Ui.ZoomPhoto.open(null, {loop: false, items, index});
    }

    /** 한 오더의 사진만 넘기는 뷰어 (지도 핀 — 대표 오더는 목록에 없다) */
    _showOrder(o, index = 0) {
        if (!o || !o.photos.length) return;
        $j.Ui.ZoomPhoto.open(null, {
            loop: false,   // 몇 장인지 세며 넘긴다 — 끝에서 처음으로 돌면 끝을 모른다
            items: o.photos.map((p, n) => this._item(o, p, n)),
            index,
        });
    }

    /** 사진 한 장 → 뷰어 항목. 장수(n/length)는 그 오더 안에서 세고 오더번호로 어느 오더인지 보인다.
     *  주소는 서버가 만든 것을 그대로 준다 — JS 는 호스트 번호→도메인 표를 모른다 (DocMaster.js 참고) */
    _item(o, p, n) {
        return {
            url: p.url,
            caption: `${o.carType} ${o.carOption} · ${o.area}`,
            meta: `${n + 1}/${o.photos.length}장`
                + (p.tag ? ` · ${p.tag}` : '')
                + (p.date ? ` · ${p.date}` : '')
                + ` · 오더 ${o.num}`,
        };
    }

    _listHtml(res) {
        if (!res.orders.length) {
            const where = this.mode === 'map' ? '지도에 보이는 영역에 ' : '';
            return `<p class="text-muted mb-0 p-3">${where}고른 조건으로 보여줄 작업사진이 없습니다.</p>`;
        }

        const cards = res.orders.map((o, i) => {
            const first = o.photos[0];
            // 사진 자리를 늘 깔고 그 위에 사진을 얹는다 — 파일이 사라졌으면 사진만 지워 자리가 드러난다
            const thumb = `<div class="opg-none">${first ? '사진 깨짐' : '사진 없음'}</div>`
                + (first ? `<img src="${this._esc(first.thumb)}" alt="" loading="lazy" decoding="async" onerror="this.remove()">` : '');
            const badge = o.photos.length > 1 ? `<span class="opg-badge">${o.photos.length}장</span>` : '';

            return `<div class="opg-card" data-i="${i}">
                <div class="opg-thumb">${thumb}${badge}</div>
                <div class="opg-name" title="${this._esc(o.carType + ' ' + o.carOption)}">${this._esc(o.carType)} ${this._esc(o.carOption)}</div>
                <div class="opg-meta" title="${this._esc(o.area)}">${this._esc(o.area)}</div>
                <div class="opg-meta">${this._esc(o.workDay)} · ${this._esc(o.worker)}
                    · <a href="javascript:;" class="opg-order" data-n="${o.num}" title="오더 핸들 열기">${o.num}</a></div>
            </div>`;
        }).join('');

        return `<div class="opg-grid">${cards}</div>${this._navHtml(res)}`;
    }

    /** 쪽 넘기기 — DocMaster._galleryNav 와 같은 모양 (처음·이전·번호 10개·다음·마지막) */
    _navHtml(res) {
        const pages = Math.ceil(res.total / res.perPage) || 1;
        const from  = (res.page - 1) * res.perPage + 1;
        const to    = Math.min(res.page * res.perPage, res.total);
        const info  = `<div class="dt-info" role="status">
            ${res.total.toLocaleString()}건 중 ${res.total ? from.toLocaleString() : 0}–${to.toLocaleString()}
        </div>`;
        if (pages <= 1) return `<div class="opg-foot">${info}</div>`;

        const WIN = 10;
        let start = Math.max(1, res.page - Math.floor(WIN / 2));
        let end   = Math.min(pages, start + WIN - 1);
        start     = Math.max(1, end - WIN + 1);

        const btn = (label, p, cls) => {
            const off = p < 1 || p > pages || p === res.page;
            return `<button type="button" class="dt-paging-button ${cls}${off && cls.indexOf('current') < 0 ? ' disabled' : ''}"
                ${off ? 'disabled' : `data-p="${p}"`}>${label}</button>`;
        };

        let body = '';
        for (let p = start; p <= end; p++) body += btn(p, p, p === res.page ? 'opg-page current' : 'opg-page');

        return `<div class="opg-foot">
            ${info}
            <div class="dt-paging paging_full_numbers">
                ${btn('«', 1, 'opg-page first')}
                ${btn('‹', res.page - 1, 'opg-page previous')}
                ${start > 1 ? '<span class="dt-paging-button ellipsis disabled">…</span>' : ''}
                ${body}
                ${end < pages ? '<span class="dt-paging-button ellipsis disabled">…</span>' : ''}
                ${btn('›', res.page + 1, 'opg-page next')}
                ${btn('»', pages, 'opg-page last')}
            </div>
        </div>`;
    }

    _esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
            ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
    }
}
